// A hora de uma mensagem da conversa de teste (L-18): HH:MM, em 24 horas, no fuso do navegador de
// quem abre. `idioma` é o da tela (`pt_BR` ou `en`); a forma é a mesma nos dois.
export const horaDe = (iso, idioma = 'pt_BR') => {
  const data = new Date(iso || '');
  if (Number.isNaN(data.getTime())) return '';
  return new Intl.DateTimeFormat(String(idioma).replace('_', '-'), {
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).format(data);
};
